import { BtText } from '@linqpal/components/src/ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { View, TouchableOpacity } from 'react-native'
import { styles } from './styles'
import projectsStore from '../../../Store'
import { observer } from 'mobx-react'

type FooterProps = {
  onEdit: () => void
}
export const FooterEditSidebar = observer(({ onEdit }: FooterProps) => {
  const { t } = useTranslation('global')
  const { noteIsTypingNow } = projectsStore
  return (
    <View style={styles.footer}>
      <TouchableOpacity
        activeOpacity={0.8}
        style={noteIsTypingNow ? styles.activeBtn : styles.button}
        onPress={onEdit}
        disabled={noteIsTypingNow}
      >
        <BtText
          style={
            noteIsTypingNow
              ? styles.buttonLabelNotActive
              : styles.buttonLabelActive
          }
        >
          {t('Projects.edit')}
        </BtText>
      </TouchableOpacity>
    </View>
  )
})
